module.exports = __webpack_public_path__ + "c5027d2a4adaa718a2c57450b1f6bb8b.png";